import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getInterventionsCategories = () => {
    return request({
        url: namespace + "/interventionscategories",
        method: "get",
    });
};

export const getInterventionCategory = (ig_id) => {
    return request({
        url: namespace + "/interventionscategorie/" + ig_id,
        method: "get",
    });
};

export const createInterventionCategory = (payload) => {
    return request({
        url: namespace + "/interventionscategorie",
        data: payload,
        method: "post",
    });
};

export const updateInterventionCategory = (payload) => {
    return request({
        url: namespace + "/interventionscategorie",
        data: payload,
        method: "put",
    });
};

export const destroyInterventionCategory = (ig_id) => {
    return request({
        url: namespace + "/interventionscategorie/" + ig_id,
        method: "delete",
    });
};